
import { Loader2 } from "lucide-react";

export function LoadingResults() {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <Loader2 className="h-12 w-12 text-primary animate-spin mb-4" />
      <p className="text-muted-foreground">Generating creative ideas...</p>
    </div>
  );
}
